import { UserAuditView } from "./usersView/userAuditView";
import { AuditContextProvider } from "./auditsView/auditContext";
import { AuditTab, AuditTabGroup } from "./auditTabs";
import { AuditDetails } from "./auditsView/auditDetails";
import { SearchAuditFilter } from "./auditsView/searchAuditFilter";
import { FormattedMessage, useIntl } from "react-intl";

export interface AuditProps {}
export function Audits(props: AuditProps) {
  function resetTabs(tabName: string) {}
  const intl = useIntl();

  return (
    <div className="flex flex-col w-full h-full">
      <div className="flex items-center justify-between w-full mb-4">
        <div className="flex-grow">
          <AuditTabGroup defaultTabName="userView" onClick={resetTabs}>
            <AuditTab name="userView" title={intl.formatMessage({id:"auditTab.traineeView"})}>
              <UserAuditView />
              <div></div>
            </AuditTab>
            <AuditTab name="auditView" title={intl.formatMessage({id:"auditTab.auditView"})}>
              <AuditContextProvider>
                <div className="text-mk-primary-bright text-2xl font-semibold">
                  <FormattedMessage id="auditView.searchAudit" />
                </div>
                <div className="pb-[1%]"></div>
                <SearchAuditFilter />
                <AuditDetails />
              </AuditContextProvider>
              <div></div>
            </AuditTab>
          </AuditTabGroup>
        </div>
      </div>

      <div className="w-full"></div>
    </div>
  );
}
